export default {"src":"/_next/static/media/logo--white.b03e5315.svg","height":140,"width":900,"blurWidth":0,"blurHeight":0};